import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { createVuetify } from 'vuetify';
import { satelliteOpts } from '@satellite/plugins/vuetify.js';
import type { VuetifyOptions } from 'vuetify';

const opts: VuetifyOptions = {
  ...satelliteOpts
};

export default createVuetify(opts);
